const initialState = {
  loading: false,
  items: [],
  groupModifiers: true,
};

const itemsSoldReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'FETCH_ITEMS_SOLD_REQUEST': {
      return {
        ...state,
        items: [],
        loading: true,
      };
    }
    case 'FETCH_ITEMS_SOLD_SUCCESS': {
      return {
        ...state,
        items: action.payload.map((item) => ({
          categoryName: item.category_name,
          refundReason: item.refund_reason,
          quantity: item.quantity,
          unitPrice: {
            formatted: item.unit_price.formatted,
          },
          totalUnitPrice: {
            formatted: item.total_unit_price.formatted,
          },
          totalPrice: {
            formatted: item.total_price.formatted,
          },
          name: item.name,
          category: item.category_name,
          modifiers: item.modifiers.map((modifier) => ({
            name: modifier.name,
          })),
        })),
        loading: false,
      };
    }
    case 'FETCH_ITEMS_SOLD_FAILURE': {
      return {
        ...state,
        status: action.status,
        loading: false,
        items: [],
      };
    }
    case 'SET_ITEMS_SOLD_GROUP_MODIFIERS': {
      return {
        ...state,
        groupModifiers: action.value,
      };
    }
    default:
      return state;
  }
};

export default itemsSoldReducer;
